
import { Component, Input, OnInit } from '@angular/core';
import { CollapseModule } from 'ngx-bootstrap/collapse';

@Component({
  selector: 'notice-section',
  templateUrl: './notice-section.component.html',
  standalone: true,
  imports: [CollapseModule]
})
export class NoticeSectionComponent implements OnInit {
  @Input() details: any
  public isCollapsed = -1;

  constructor() {
  }

  ngOnInit(): void {
  }


}
